import i18n from '@/i18n';

export default [
  {
    path: '/threads',
    name: 'threads',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'thread',
          actions: ['view'],
        },
      ],
      title: i18n.global.t('deals')
    },
    // route level code-splitting
    component: () =>
      import('../../views/threads/Index.vue'),
    children: [
      {
        path: 'new-deal',
        name: 'threads-new-deal',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'thread',
              actions: ['store-deal'],
            },
          ],
          title: i18n.global.t('deals'),
        },
        component: () => import('../../views/threads/AddDeal.vue'),
      },
      {
        path: 'new-campaign',
        name: 'threads-new-campaign',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'thread',
              actions: ['store-campaign'],
            },
          ],
          title: i18n.global.t('deals'),
        },
        component: () => import('../../views/threads/AddCampaign.vue'),
      },
      {
        path: ':id(\\d+)',
        name: 'thread-edit',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'thread',
              actions: ['view'],
            },
          ],
          title: i18n.global.t('deals'),
        },
        component: () => import('../../views/threads/EditThread.vue'),
      },
      {
        path: ':id(\\d+)/comment',
        name: 'threads-add-comment',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'thread',
              actions: ['view'],
            },
          ],
          title: i18n.global.t('deals'),
        },
        component: () => import('../../views/threads/AddComment.vue'),
      },
    ],
  },
  {
    path: '/threads/archived',
    name: 'archived-threads',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'thread',
          actions: ['view-archived'],
        },
      ],
      title: i18n.global.t('archived_deals')
    },
    // route level code-splitting
    component: () =>
      import('../../views/threads/Archived'),
    children: [
      {
        path: ':id(\\d+)',
        name: 'archived-thread-edit',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'thread',
              actions: ['view-archived'],
            },
          ],
          title: i18n.global.t('archived_deals'),
        },
        component: () => import('../../views/threads/EditThread.vue'),
      },
      {
        path: ':id(\\d+)/comment',
        name: 'archived-thread-add-comment',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'thread',
              actions: ['view-archived'],
            },
          ],
          title: i18n.global.t('archived_deals'),
        },
        component: () => import('../../views/threads/AddComment.vue'),
      },
    ],
  },
];

